import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter as Router } from "react-router-dom";
import App from "./App";

let container = document.getElementById('root');
createRoot(container).render(
    <React.StrictMode>
        <Router>
            <App />
        </Router>
    </React.StrictMode>
);


